var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageinput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3832 13.658H2.49805V7.76271C2.49805 7.44916 2.64519 7.15709 2.88765 6.9898L9.77092 2.23627C10.1802 1.9538 10.701 1.9538 11.1103 2.23627L17.9936 6.9898C18.236 7.15755 18.3832 7.44916 18.3832 7.76271V13.658Z",
    fill: "url(#paint0_linear_1647_166709)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8746 14.8225H5.00586V6.59525C5.00586 6.34295 5.19314 6.13818 5.42389 6.13818H15.4566C15.6873 6.13818 15.8746 6.34295 15.8746 6.59525V14.8225Z",
    fill: "url(#paint1_linear_1647_166709)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3827 7.96631V17.6818C18.3827 18.122 18.0508 18.4789 17.6411 18.4789H4.40381L6.4116 15.587L18.3827 7.96631Z",
    fill: "url(#paint2_linear_1647_166709)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49805 7.96631V17.6818C2.49805 18.122 2.82996 18.4789 3.23963 18.4789H17.642C17.8761 18.4789 18.0822 18.3601 18.218 18.1782L2.49805 7.96631Z",
    fill: "url(#paint3_linear_1647_166709)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3214 9.33756H10.8583V7.73781C10.8583 7.61166 10.7646 7.50928 10.6493 7.50928H10.2312C10.1159 7.50928 10.0222 7.61166 10.0222 7.73781V9.33756H8.55911C8.44374 9.33756 8.3501 9.43994 8.3501 9.5661V10.0232C8.3501 10.1493 8.44374 10.2517 8.55911 10.2517H10.0222V11.8514C10.0222 11.9776 10.1159 12.08 10.2312 12.08H10.6493C10.7646 12.08 10.8583 11.9776 10.8583 11.8514V10.2517H12.3214C12.4368 10.2517 12.5304 10.1493 12.5304 10.0232V9.5661C12.5304 9.43994 12.4368 9.33756 12.3214 9.33756Z",
    fill: "url(#paint4_linear_1647_166709)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1647_166709",
    x1: 8.31743,
    y1: 2.80852,
    x2: 11.3786,
    y2: 12.2579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0858A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1647_166709",
    x1: 10.4402,
    y1: 6.32833,
    x2: 10.4402,
    y2: 12.6437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F8F8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1647_166709",
    x1: 11.2286,
    y1: 12.9648,
    x2: 16.9163,
    y2: 20.4097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA0E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1647_166709",
    x1: 1.69292,
    y1: 12.6449,
    x2: 17.6088,
    y2: 19.7041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B88DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1647_166709",
    x1: 10.4402,
    y1: 7.44072,
    x2: 10.4402,
    y2: 12.1234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21AD64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageinput);
export default __webpack_public_path__ + "static/media/messageinput.960adcaedd4b5ac8538ce98075feb9f7.svg";
export { ForwardRef as ReactComponent };